import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Financeiro: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Financeiro
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          Módulo financeiro em desenvolvimento...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Financeiro;

